import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {
  Checkbox,
  Typography,
  MenuItem,
  Tooltip,
  Select,
  FormControl,
  InputLabel,
} from '@material-ui/core';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import {
  displayErrorMessage,
} from 'Helpers/FacetNotificationManager';
import {
  usePortfolioDispatchContext,
  usePortfolioStateContext,
} from 'Components/UI/Portfolio/PortfolioContext';
import {
  toggleAccountType,
  toggleAccount,
} from 'Components/UI/Portfolio/PortfolioActions';
import useSortedAndFilteredAccounts from './useSortedAndFilteredAccounts';

const styles = theme => ({
  root: {
    alignItems: 'center',
  },
  accountSection: {
    display: 'flex',
    alignItems: 'center',
    margin: theme.spacing(0.5),
    width: theme.dimensions.xs,
  },
  menu: {
    width: theme.dimensions.xs,
  },
  expandMore: {
    marginLeft: 'auto',
  },
  select: {},
});

function PortfolioQueryWidget({ className, classes }) {
  const dispatch = usePortfolioDispatchContext();
  const state = usePortfolioStateContext();
  const { householdResource } = useSimpleHousehold();
  const [accounts, setAccounts] = React.useState(null);
  const sortedAccounts = useSortedAndFilteredAccounts(accounts, false);

  React.useEffect(() => {
    if (householdResource) {
      householdResource
        .relationship('accounts')
        .link('related')
        .Get()
        .then(accs => setAccounts(accs))
        .catch(err => displayErrorMessage(err, err.errors));
    }
  }, [householdResource]);

  const portfolioAccountType = state.accountTypes || [];
  const { excludedAccountIds } = state;

  const AccountMenuItems = sortedAccounts?.reduce(
    (components, { id, label, accounts: accs }) => {
      const typeItem = (
        <div>
          <MenuItem
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              toggleAccountType(id, dispatch, state);
            }}
          >
            <Checkbox
              disabled={state.loading}
              checked={portfolioAccountType?.includes(id)}
            />
            <Typography component="h6" color="primary" noWrap>
              {label}
            </Typography>
          </MenuItem>
        </div>
      );

      const accItems = accs.map((account) => {
        return (
          <Tooltip title={account.attr('name')}>
            <MenuItem
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                toggleAccount(account.id(), dispatch, state);
              }}
              disabled={!portfolioAccountType?.includes(id) || state.loading}
            >
              <Checkbox
                style={{
                  marginLeft: '32px',
                }}
                disabled={state.loading}
                size="small"
                checked={!excludedAccountIds?.includes(account.id())}
              />
              <Typography component="p" noWrap>
                {account.attr('name')}
              </Typography>
            </MenuItem>
          </Tooltip>
        );
      });

      return [typeItem, ...accItems, ...components];
    },
    [],
  );

  return (
    <FormControl className={classNames(classes.root, className)}>
      <InputLabel className={classes.label}>Accounts</InputLabel>
      <Select
        className={classes.select}
        helperText="Accounts"
        name="Accounts"
        fullWidth
      >
        {AccountMenuItems}
      </Select>
    </FormControl>
  );
}

PortfolioQueryWidget.defaultProps = {
  className: '',
};

PortfolioQueryWidget.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(PortfolioQueryWidget);
